import './Button.scss';
import { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Button = forwardRef((props, ref) => {
  const { color, size, className, children, type, ...rest } = props;

  const classes = ['button'];
  classes.push(`button--color-${color}`);
  classes.push(`button--size-${size}`);

  if (className.length > 0) {
    classes.push(className);
  }

  return (
    <button
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      ref={ref}
      // eslint-disable-next-line react/button-has-type
      type={type}
      className={classes.join(' ')}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';

Button.propTypes = {
  color: PropTypes.oneOf([
    'primary',
    'primary-link',
    'secondary',
    'danger-outline',
  ]),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
};

Button.defaultProps = {
  color: 'primary',
  size: 'medium',
  className: '',
  type: 'button',
};

export default Button;
